<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <fc-corporation-list
    [baseId]="baseId"
    [form]="form"
    [listItem]="listItem"
    [isSubmitted]="isSubmitted"
    [itemContext]="fcModalItemContext"
    ></fc-corporation-list>
    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-corp-notes" translate>Notes</label>
      <textarea
      class="form-control"
      [ngClass]="{ error: showErrors(corpNotesControl, isSubmitted), 'required': isRequired(corpNotesControl) }"
      id="{{ baseId }}-corp-notes"
      [maxlength]="fcListValidation.validations.CorpNotes.MaxLength"
      formControlName="corpNotes"
      rows="3"
      >
    </textarea>
    <div *ngIf="showErrors(corpNotesControl, isSubmitted)" id="{{ baseId }}-warning-text-corp-notes" class="incorrect-input" translate>
      {{ corpNotesControl.errors | fcListValidation : 'Notes' }}
    </div>
  </div>
  <!-- Notes Control -->

  <!-- Inactive checkbox -->
  <div class="checkbox-group">
    <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
  </div>
  <!-- Inactive checkbox -->
</div>
</fc-general-modal>
